// 投票機能のフラグ（環境変数やビルド時に上書き可能）
export const VOTING_ENABLED = false;


